import { Fragment } from 'react';
import { round } from 'lodash';
import { type Column as TableColumn } from 'further-ui/components/Table';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { numberToCurrencyString } from 'further-ui/utils';
import { CashFlowStatementRow } from '../types';

type Props = {
  baseCurrency: CurrencyCode;
  header1: string;
  header2: string;
  header3: string;
};

export default function getColumns({
  baseCurrency,
  header1,
  header2,
  header3,
}: Props) {
  const columns: Array<TableColumn<CashFlowStatementRow>> = [
    {
      key: 'label',
      label: 'Account category',
      minWidth: 500,
      weight: 2,
      noWrap: true,
      withVerticalBorder: true,
    },
    {
      key: 'period1',
      label: withLineBreaks(header1),
      render: ({ period1 }) => formatValue(period1, baseCurrency),
      weight: 1,
      noWrap: true,
      withVerticalBorder: true,
    },
    {
      key: 'period2',
      label: withLineBreaks(header2),
      render: ({ period2 }) => formatValue(period2, baseCurrency),
      weight: 1,
      noWrap: true,
      withVerticalBorder: true,
    },
    {
      key: 'period3',
      label: withLineBreaks(header3),
      render: ({ period3 }) => formatValue(period3, baseCurrency),
      weight: 1,
      noWrap: true,
    },
  ];

  return columns;
}

function withLineBreaks(text: string) {
  return text.split('\n').map((line, index) => (
    <Fragment key={index}>
      {line}
      {index < text.split('\n').length - 1 && <br />}
    </Fragment>
  ));
}

function formatValue(value: number, baseCurrency: CurrencyCode) {
  const rounded = round(value, 2);
  const forDisplay = rounded === 0 ? 0 : rounded;
  return numberToCurrencyString(forDisplay, {
    currency: baseCurrency,
    negativeInBrackets: true,
  });
}
